import { createFileRoute } from '@tanstack/react-router';

import { ComplianceReportPage } from '@/features/nis2/components/ComplianceReportPage';

export const Route = createFileRoute('/_authenticated/nis2/reports/compliance')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <ComplianceReportPage />
      </div>
    </div>
  );
}
